export function SituationExamples(): React.JSX.Element {
  return <aside className="intake-examples" aria-labelledby="intake-examples-title">
    <h3 id="intake-examples-title">이렇게 적어 보세요</h3>
    <p>어디가 불편한지 → 언제부터인지 → 어떤 때 더 불편한지 순서로 적어 주세요.</p>
    <blockquote><span>작성 예시</span>어제부터 오른쪽 무릎이 아파요. 계단을 오를 때 더 아파요. 먹는 약 이름은 잘 모르겠어요.</blockquote>
    <details><summary>다른 예문 보기</summary><blockquote>며칠 전부터 기침이 나요. 밤에 누우면 더 심해요. 혈압약을 먹고 있는데 이름은 모르겠어요.</blockquote><blockquote>오늘 아침부터 속이 더부룩해요. 밥을 먹고 나면 더 불편해요. 약 알레르기가 있는지는 모르겠어요.</blockquote></details>
    <p className="privacy-note">예문을 그대로 쓰지 말고, 내 상황에 맞게 적어 주세요. 짧게 적어도 괜찮아요. 모르는 내용은 ‘모르겠어요’라고 쓰세요.</p>
  </aside>;
}
